import { css, CSSResult } from 'lit';

export const reset = {
  button: css`
    :where(button) {
      border: 0;
      padding: 0;
      font-family: inherit;
      font-size: inherit;
      background: none;
      cursor: pointer;
    }
  `,
  a: css`
    :where(a) {
      color: inherit;
      text-decoration: none;
    }
  `,
};

export const resetCss: CSSResult = css`
  /* Box sizing rules */
  :where(*, *::before, *::after) {
    box-sizing: border-box;
  }

  /* Remove default margin */
  :where(body, h1, h2, h3, h4, h5, h6, p, figure, blockquote, dl, dd, ul, ol) {
    margin: 0;
  }

  /* Remove list styles on ul, ol elements with a list role, which suggests default styling will be removed */
  :where(ul[role='list'], ol[role='list']) {
    list-style: none;
  }

  /* Set core root defaults */
  :where(html:focus-within) {
    scroll-behavior: smooth;
  }

  /* Give anchor and button element a cursor pointer */
  :where(button, a) {
    cursor: pointer;
  }

  /* A elements that don't have a class get default styles */
  :where(a:not([class])) {
    text-decoration-skip-ink: auto;
  }

  /* Make images easier to work with */
  :where(img, picture) {
    display: block;
    max-inline-size: 100%;
  }

  /* Inherit fonts for inputs and buttons */
  :where(input, button, textarea, select) {
    font: inherit;
  }

  /* Reset button styles */
  :where(button) {
    padding: 0;
    border: 0;
    background: none;
    color: inherit;
    font-size: inherit;
    line-height: normal;
    text-align: inherit;
  }

  /* Remove all animations, transitions and smooth scroll for people that prefer not to see them */
  @media (prefers-reduced-motion: reduce) {
    html:focus-within {
      scroll-behavior: auto;
    }

    *,
    *::before,
    *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      scroll-behavior: auto !important;
      transition-duration: 0.01ms !important;
    }
  }
`;
